import { createApi } from '@reduxjs/toolkit/query/react';
import { BASE_URL_V3, STORE_BASE_PATH } from '../../common/constants';
import { baseQueryWithReauth } from './baseQueryWithReauth';

export const facadeApiV3 = createApi({
    reducerPath: `${STORE_BASE_PATH}facadeApiV3`,
    baseQuery: baseQueryWithReauth(BASE_URL_V3),
    endpoints: () => ({}),
});
